import { jsx as _jsx } from "react/jsx-runtime";
import LiveBoardTabComponent from "../live-board-tab-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import { notificationsGridItems } from "./notifications-tab-consts.js";
const NotificationsTabContentComponent = (props)=>{
    const { translate, onCardClick } = props;
    return /*#__PURE__*/ _jsx("div", {
        className: "notifications-tab-content",
        children: /*#__PURE__*/ _jsx(LiveBoardTabComponent, {
            description: translate("liveBoard.notificationsTab.description"),
            gridItems: notificationsGridItems,
            onCardClick: onCardClick,
            hideCardParagraph: true
        })
    });
};
export default withGenericConfig(NotificationsTabContentComponent);
